<template>
  <div class="content-item tx-testimonials testimonial-list">
    <div class="list__filter"></div>
    <div class="list__wrapper">
      <div class="list-item" v-for="(item, index) in testimonials"
           :key="`testimonial__item--${item.uid}`"
           :class="{ '-special': isSpecialItem(index), '-display-none': index>=(currentPage*itemsPerPage)}">
          <a v-if="item.link && index<(currentPage*itemsPerPage)" :href="item.link">
            <div v-if="item.image" class="list-element__image_wrapper">
                <img :src="item.image.split('|')[0]" :title="item.image.split('|')[1]"
                     :alt="item.image.split('|')[2]">
                <div class="list-element__category">
                  <span>{{ item.category.title }}</span>
                </div>
            </div>
            <div class="list-element__content">
              <div class="content__info">
                <div class="content__gradient"></div>
                <div v-if="item.title" class="content__headline">
                  <span class="heading delta">{{ item.title }}</span>
                </div>
                <div v-if="item.text" class="content__text">
                  <span v-html="item.text"></span>
                </div>
              </div>
              <div class="content__button">
                <span class="icon-read-more-before">{{ $t('testimonials.list.readMore') }}</span>
              </div>
            </div>
          </a>
      </div>
      <div class="list-item list-item-placeholder"></div>
    </div>
    <div class="content-item module-load-more" v-if="numberOfTotalItems > 0">
      <div class="load-more__button" v-if="currentPage < numberOfPages">
        <div class="btn -btn-alpha" @click="loadMoreEntries">
          <span>{{ $t('testimonials.pagination.button') }}</span>
        </div>
      </div>
      <div class="load-more__progress" v-if="loaded">
        <div class="progress__info">
          <span class="meta" v-html="$t('testimonials.pagination.info', { current: testimonials.length, total: numberOfTotalItems })"></span>
        </div>
        <div class="progress__bar"><span :style="{ width: (testimonials.length / numberOfTotalItems * 100) + '%' }"></span></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'App',
  data () {
    return {
      screenSize: window.innerWidth
    }
  },
  computed: {
    ...mapState({
      testimonials: 'testimonials',
      currentPage: 'currentPage',
      itemsPerPage: 'itemsPerPage',
      numberOfPages: 'numberOfPages',
      numberOfTotalItems: 'numberOfTotalItems',
      loaded: 'loaded'
    }),
    mobile () {
      return this.screenSize < 640
    },
    tabletPortrait () {
      return (this.screenSize >= 640 && this.screenSize < 1024)
    },
    tabletLandscape () {
      return (this.screenSize >= 1024 && this.screenSize < 1440)
    },
    notebook () {
      return (this.screenSize >= 1440 && this.screenSize < 1680)
    },
    desktop () {
      return this.screenSize >= 1680
    }
  },
  methods: {
    loadMoreEntries: function () {
      this.increasePage()
      this.getTestimonials()
    },
    isSpecialItem: function (index) {
      if (this.mobile || this.tabletPortrait || this.tabletLandscape) {
        return (this.testimonials.length > 3 && index === 2 && this.testimonials.length < 7) || (this.testimonials.length > 6 && index === 6)
      } else if (this.notebook || this.desktop) {
        return (this.testimonials.length > 3 && index === 3 && this.testimonials.length < 7) || (this.testimonials.length > 6 && index === 6)
      }
    },
    ...mapActions([
      'getTestimonials',
      'increasePage'
    ])
  },
  created () {
    const self = this
    self.getTestimonials()
    window.addEventListener('resize', () => {
      self.screenSize = window.innerWidth
    })
  }
}
</script>
